export const api = {
	listRevenueAnalysis4OrderAmount: '/mall/listRevenueAnalysis4OrderAmount',
	listRevenueAnalysis4OrderCount: '/mall/listRevenueAnalysis4OrderCount',
	exportRevenueAnalysis4OrderAmount: '/mall/exportRevenueAnalysis4OrderAmount',
	exportRevenueAnalysis4OrderCount: '/mall/exportRevenueAnalysis4OrderCount'
};

export const routes = {
	'/revenue-analysis': '营收统计',
};
